import { isNumber } from "es-toolkit";
import { Header } from "@radix-ui/react-accordion";
import { ChevronIcon } from "../../../materials/icons/chevron-icon/ChevronIcon";
import { Body } from "../../body/Body";
import { StatusChip } from "../../status-chip/StatusChip";
import { MinusIcon } from "../icons/minus-icon/MinusIcon";
import { PlusIcon } from "../icons/plus-icon/PlusIcon";
import {
  Content,
  Item,
  ItemNumberContainer,
  Props,
  TitlesContainer,
  ToggleIconContainer,
  Trigger,
  padNumber,
} from "./AccordionItem.Parts";

export const AccordionItem = ({
  value,
  title,
  content,
  disabled = false,
  subtitle,
  status,
  statusVariant,
  numbered = false,
  index,
  toggleIcon = "plus-minus",
  showBorder = true,
  $padding,
}: Props) => {
  if (!value) throw new Error("AccordionItem requires a value prop");

  return (
    <Item value={value} key={value} $showBorder={showBorder}>
      <Header>
        <Trigger
          tabIndex={disabled ? -1 : 0}
          disabled={disabled}
          $padding={$padding}
        >
          {numbered && isNumber(index) && (
            <ItemNumberContainer>
              <Body>{padNumber(index)}</Body>
            </ItemNumberContainer>
          )}
          <TitlesContainer>
            {typeof title === "string" ? (
              <Body variant="normal-strong">{title}</Body>
            ) : (
              title
            )}
            {subtitle && <Body variant="small">{subtitle}</Body>}
          </TitlesContainer>
          {status && <StatusChip variant={statusVariant} label={status} />}
          <ToggleIconContainer>
            {toggleIcon === "plus-minus" ? (
              <PlusIcon />
            ) : (
              <ChevronIcon orientation="down" />
            )}
            {toggleIcon === "plus-minus" ? (
              <MinusIcon />
            ) : (
              <ChevronIcon orientation="up" />
            )}
          </ToggleIconContainer>
        </Trigger>
      </Header>
      <Content $padding={$padding}>{content}</Content>
    </Item>
  );
};
